import { Component, OnDestroy, OnInit, Optional, ViewChild, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { MenuItem } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { Subscription } from 'rxjs';

import { ENVIRONMENT } from '@environment';
import { AuthService } from '@usheru-hff/authentication/domain';
import { User } from '@usheru-hff/shared/domain';
import { AuthenticationModalService } from '@usheru-hff/shared/utils-authentication';
@Component({
  selector: 'ush-user-dropdown-community',
  templateUrl: './user-dropdown-community.component.html',
  styleUrls: ['./user-dropdown-community.component.scss'],
  standalone: false
})
export class UserDropdownCommunityComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly uiAuthService = inject(AuthenticationModalService);
  private readonly env = inject(ENVIRONMENT);

  @ViewChild(Menu) userMenu: Menu;

  /**
   * Entries in the dropdown with the routes related to the user.
   */

  userMenuItems: MenuItem[];

  /**
   * Name of the actual user if is logged.
   */
  user = signal<User | undefined>(undefined);

  /**
   * Obserbable to get the current user logged data.
   */
  private userSubscription: Subscription;

  userIcon = faUser;

  ngOnInit(): void {
    this.fillUserMenuItems();
    this.listenUserAuth();
  }

  listenUserAuth() {
    this.userSubscription = this.authService.$userStatus.subscribe(user => {
      this.user.set(user || undefined);
      this.fillUserMenuItems();
    });
  }

  /**
   * Sets the info and actions of the user menu ({@link userMenuItems}).
   */
  private fillUserMenuItems(): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const userActions: { label: string; command: (event: any) => void }[] = [
      {
        label: $localize`:@@public.header.link.profile:My account`,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        command: event => {
          this.router.navigate(['/profile', this.user().username]);
        }
      }
    ];

    userActions.push({
      label: $localize`:@@public.header.link.logout:Log out`,
      command: event => {
        this.logout();
      }
    });

    this.userMenuItems = [];

    if (this.user) {
      for (const action of userActions) {
        this.userMenuItems.push({
          label: action.label,
          command: action.command
        });
      }
    }
  }

  /**
   * Trigger logout of the {@link AuthService}
   */
  logout(): void {
    this.authService.logout('', true);
    sessionStorage.setItem('isLoggedOut', 'true');
    this.reloadPage();
  }

  private reloadPage(): void {
    window.location.reload();
  }

  login(): void {
    this.uiAuthService.redirectToLogin();
  }

  /**
   * @docsNotRequired
   */
  goToFilms(): void {
    this.router.navigate(['/my-films']);
  }

  get isCommunitySocialEnabled(): boolean {
    if (this.env.communityConfig?.role === undefined) return true;
    return this.env.communityConfig?.role === 'community-social';
  }

  get compacted(): boolean {
    return this.env.communityConfig?.userChipCompacted;
  }

  onDropdownClick(event: Event): void {
    this.userMenu.toggle(event);
  }

  /**
   * //TODO barbeitoalex - this is necessary?
   */
  ngOnDestroy() {
    this.userSubscription.unsubscribe();
  }
}
